export function stationLink(value){
  try{const url=new URL(value);return ['https:','http:'].includes(url.protocol)&&!url.username&&!url.password?url.href:null;}catch{return null;}
}
export function stationList(value){
  const list=Array.isArray(value)?value:String(value||'').split(',');
  return [...new Set(list.map(item=>String(item).trim()).filter(Boolean))];
}
export function stationInfo(station){
  const tags=stationList(station.tags),languages=stationList(station.language),bitrate=Number(station.bitrate);
  const rows=[
    ['Bitrate',Number.isFinite(bitrate)&&bitrate>0?`${bitrate} kbps`:'Not provided'],
    ['Country',station.country||station.countrycode||'Not provided'],
    ['Languages',languages.join(', ')||station.languagecodes||'Not provided'],
    ['Genre / format',stationList(station.genre||station.genres).join(', ')||tags.slice(0,3).join(', ')||'Not provided'],
  ];
  const optional=[['Region',station.state],['Subdivision',station.iso_3166_2],['Codec',station.codec],['Stream format',station.hls==null?null:Number(station.hls)===1?'HLS':'Direct audio'],['Tune Mondo listens',station.listen_count]];
  rows.push(...optional.filter(([,value])=>value!==null&&value!==undefined&&String(value).trim()!==''));
  return {rows,tags,genreFromTags:!station.genre&&!station.genres&&tags.length>0,links:[['Website',stationLink(station.homepage)]].filter(([,url])=>url)};
}
